

































































































import {
  ref,
  defineComponent,
  computed,
  watch,
  reactive,
  watchEffect,
} from "@vue/composition-api";
import router from "./../router/index";
import store from "./../store/index";
import workOrderDialog from "./../components/Dialogs/workOrder.vue";
export default defineComponent({
  name: "WorkOrder",
  components: { workOrderDialog },
  setup() {
    const stop = watchEffect(() => {
      // if (!store.state.IsLogin) {
      //     console.log("logout...");
      //     router.push({
      //         name: "Main"
      //     });
      // }
    });
    const fieldServiceType = reactive(["none", "Trouble shooting"]);
    const workOrderType = reactive(["FOC", "Return"]);
    const headers = computed(() => {
      return [
        {
          text: "Work Order Number",
          value: "workWorderNumber",
          sortable: true,
          align: "center",
          width: "90",
        },
        {
          text: "Service Request",
          value: "ServiceRequest",
          sortable: false,
          align: "center",
          width: "200",
        },
        {
          text: "Sub-Status",
          value: "SubStatus",
          sortable: false,
          align: "center",
          width: "90",
        },
        {
          text: "Action",
          value: "ac",
          sortable: false,
          align: "center",
          width: "90",
        },
      ];
    });
    const tableDatas = reactive([
      {
        workWorderNumber: "ASP211108-00001",
        ServiceRequest: "",
        SubStatus: "Be Processed by CS Team",
      },
      {
        workWorderNumber: "ASP211108-00002",
        ServiceRequest: "",
        SubStatus: "Ae Processed by CS Team",
      },
    ]);
    return {
      fieldServiceType,
      workOrderType,
      headers,
      tableDatas,
    };
  },
});
